/** Granular permissions for dedicated report pages under /reports. */
export const SALES_REPORT_PERMISSIONS = {
  VIEW: 'sales_report.view',
  DOWNLOAD: 'sales_report.download',
  /** @deprecated use DOWNLOAD */
  LEGACY_DOWNLOAD: 'export_reports',
} as const;

export const SALES_ANALYTICS_PERMISSIONS = {
  VIEW: 'sales_analytics.view',
  DOWNLOAD: 'sales_analytics.download',
  /** @deprecated use VIEW */
  LEGACY_VIEW: 'view_sales_analytics',
  /** @deprecated use DOWNLOAD */
  LEGACY_DOWNLOAD: 'download_sales_analytics',
} as const;
